import { render, staticRenderFns } from "./WarningMessage.vue?vue&type=template&id=ab25c2dc&scoped=true"
import script from "./WarningMessage.vue?vue&type=script&lang=ts"
export * from "./WarningMessage.vue?vue&type=script&lang=ts"
import style0 from "./WarningMessage.vue?vue&type=style&index=0&id=ab25c2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25c2dc",
  null
  
)

export default component.exports